














import { Vue, Component, Prop } from "vue-property-decorator";
import axios from 'axios';
import { MiaPlaza } from '@/Reinforced.Typings';
import * as amplitude from '@amplitude/analytics-browser';
import { VNode } from "vue-demi";

@Component
export default class AmplitudeInitializer extends Vue {
	@Prop({required: true, type: String}) protected apiKey!: string;
	@Prop({required: false, type: String}) protected userId!: string;
	@Prop({required: false, type: Number}) protected amplitudeSessionId!: number;
	@Prop({required: false, type: String}) protected amplitudeDeviceId!: string;
	@Prop({required: false, type: Array}) protected excludeReferrers!: string[];

	protected created(): void {
		void this.initAndSyncAmplitude();
	}

	protected render(): VNode[] | undefined { return undefined; }

	private async initAndSyncAmplitude(): Promise<void> {
		if (!this.apiKey){
			return;
		}

		await amplitude.init(this.apiKey, this.userId ? this.userId.toString() : undefined, {
			defaultTracking: true,
			autocapture: {
				attribution: {
					excludeReferrers: this.excludeReferrers
				},
				elementInteractions: true
			}
		}).promise;

		const currentSessionId = amplitude.getSessionId();
		const currentDeviceId = amplitude.getDeviceId();
		
		// This shouldn't happen, but can if a user has very strict browser settings - in that case, we cannot track them
		if (!currentSessionId || !currentDeviceId) {
			return;
		}

		if (currentSessionId === this.amplitudeSessionId && currentDeviceId === this.amplitudeDeviceId) {
			return;
		}

		await axios.get<MiaPlaza.Control.Vue.Analytics.AmplitudeInitializer>(
			MiaPlaza.Control.Vue.Analytics.AmplitudeInitializer.GetSetAmplitudeDataUrl(
				currentSessionId,
				currentDeviceId
			)
		);
	}
}
